module.exports = __webpack_public_path__ + "static/media/Resume.d25ee54f.pdf";